import { ISearchService, TSearchQueryRequest } from "../service/SearchService";

export default class RunSimpleSearchQueryInteractor {
  private searchService: ISearchService;

  constructor({ searchService }: any) {
    this.searchService = searchService;
  }
  async execute(query: string | TSearchQueryRequest) {
    return this.searchService.simpleSearch(query);
  }
}
